import { useEffect } from 'react';
import settings from '../config/settings';

const SEO = ({ page = 'home' }) => {
  useEffect(() => {
    const pageMeta = settings.pageMeta[page] || settings.meta;
    const mainMeta = settings.meta;

    // Update document title
    document.title = pageMeta.title || mainMeta.title;

    // Update meta description
    updateMetaTag('description', pageMeta.description || mainMeta.description);

    // Update meta keywords
    updateMetaTag('keywords', pageMeta.keywords || mainMeta.keywords);

    // Update Open Graph tags
    updateMetaTag('og:title', pageMeta.title || mainMeta.title, 'property');
    updateMetaTag('og:description', pageMeta.description || mainMeta.description, 'property');
    updateMetaTag('og:image', mainMeta.ogImage, 'property');
    updateMetaTag('og:url', mainMeta.url, 'property');
    updateMetaTag('og:type', mainMeta.ogType, 'property');
    updateMetaTag('og:locale', mainMeta.locale, 'property');

    // Update Twitter Card tags
    updateMetaTag('twitter:card', mainMeta.twitterCard, 'name');
    updateMetaTag('twitter:title', pageMeta.title || mainMeta.title, 'name');
    updateMetaTag('twitter:description', pageMeta.description || mainMeta.description, 'name');
    updateMetaTag('twitter:image', mainMeta.ogImage, 'name');

    // Update robots and other meta tags
    updateMetaTag('robots', mainMeta.robots || 'index, follow');
    updateMetaTag('googlebot', mainMeta.googlebot || 'index, follow');
    updateMetaTag('author', mainMeta.author);

    // Update canonical URL
    updateCanonicalUrl(mainMeta.canonical || mainMeta.url);

    // Add structured data
    addStructuredData();

  }, [page]);

  const updateMetaTag = (name, content, attribute = 'name') => {
    if (!content) return;

    let element = document.querySelector(`meta[${attribute}="${name}"]`);
    if (element) {
      element.setAttribute('content', content);
    } else {
      element = document.createElement('meta');
      element.setAttribute(attribute, name);
      element.setAttribute('content', content);
      document.head.appendChild(element);
    }
  };

  const updateCanonicalUrl = (url) => {
    let canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', url);
    } else {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      canonical.setAttribute('href', url);
      document.head.appendChild(canonical);
    }
  };

  const addStructuredData = () => {
    // Remove existing structured data
    const existingScript = document.querySelector('script[type="application/ld+json"]');
    if (existingScript) {
      existingScript.remove();
    }

    // Add new structured data
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(settings.structuredData);
    document.head.appendChild(script);
  };

  return null; // This component doesn't render anything
};

export default SEO;